import { useState, useCallback, useRef, useEffect } from 'react';
import ReviewsAPI from 'api/reviews';
export const useReviews = (facilityId) => {
    const [reviews, setReviews] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [hasMore, setHasMore] = useState(true);
    const pageRef = useRef(1);
    const isFetchingRef = useRef(false);
    // Reset state when facilityId changes to prevent mixing results
    useEffect(() => {
        setReviews([]);
        setHasMore(true);
        pageRef.current = 1;
        isFetchingRef.current = false;
    }, [facilityId]);
    const fetchReviews = useCallback(() => {
        if (isFetchingRef.current || !hasMore) {
            return;
        }
        isFetchingRef.current = true;
        setIsLoading(true);
        setError(null);
        ReviewsAPI.get({ facilityId, page: pageRef.current })
            .then(response => {
            const { results = [], next } = response.data || {};
            setReviews(prev => [...prev, ...results]);
            setHasMore(Boolean(next));
            pageRef.current += 1;
        })
            .catch(() => {
            setError('Unable to load reviews. Please try again.');
        })
            .finally(() => {
            setIsLoading(false);
            isFetchingRef.current = false;
        });
    }, [facilityId, hasMore]);
    return { reviews, isLoading, error, hasMore, fetchReviews };
};
